<template>
  <div class="customer_service">
    <div class="customer_service_inner">
      <nuxt-child />
    </div>
  </div>
</template>

<script>
import '~/assets/css/cs.scss'

export default {
  middleware: 'checkLogin',
  data() {
    return {}
  },
  mounted() {
    this.$xlaPush('custom_service_page_show')
  },
  methods: {}
}
</script>
